import { Box, Typography } from "@mui/material";
import { muiTheme } from "../theme/theme";

const StepProgressBar = ({
  currentStep = 1,
  totalSteps = 3,
  stepTitle = "",
}) => {
  const progressPercent = (currentStep / totalSteps) * 100;

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: "10px",
        }}
      >
        <Typography variant="body2" fontWeight={500}>
          Step {currentStep} of {totalSteps}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {stepTitle}
        </Typography>
      </Box>

      <Box
        sx={{
          position: "relative",
          height: "6px",
          backgroundColor: "#e0e0e0",
          borderRadius: "3px",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            height: "100%",
            width: `${progressPercent}%`,
            backgroundColor: muiTheme.palette.primary.main,
            borderRadius: "3px",
            transition: "width 0.3s ease",
          }}
        />
      </Box>
    </Box>
  );
};

export default StepProgressBar;
